import { selectEditorSettingsColumnsOptions, selectEditorSettingsData } from "../draft-selectors";
export const updateOrAddColumnOptionState = (state, columnOptionState) => {
    const columnOptionStateCopy = { ...columnOptionState };
    const columnsOptions = selectEditorSettingsColumnsOptions(state);
    if (columnsOptions && columnOptionStateCopy) {
        const index = columnsOptions.findIndex((c) => c.id === columnOptionStateCopy.id) ?? -1;
        if (index === -1) {
            columnsOptions.push(columnOptionStateCopy);
            return columnOptionStateCopy;
        }
        if (!columnsOptions[index]?.sorted) {
            columnOptionStateCopy.sortOrderSequence = undefined;
            columnOptionStateCopy.sortOrder = undefined;
        }
        columnsOptions[index] = { ...columnsOptions[index], ...columnOptionStateCopy };
        return columnsOptions[index];
    }
    return null;
};
export const updateOrAddManyColumnOptionStates = (state, columnOptionStates) => columnOptionStates
    .map((c) => updateOrAddColumnOptionState(state, c))
    .filter((c) => c !== null)
    .map((c) => c);
export const deleteManyColumnOptionStates = (state, columnOptionIds) => {
    const data = selectEditorSettingsData(state);
    if (data?.columns?.options) {
        data.columns.options = data.columns.options?.filter((columnOption) => columnOptionIds.findIndex((id) => columnOption.id === id) === -1);
    }
};
export const getColumnOptionState = (state, columnOptionId) => {
    const columnOptions = selectEditorSettingsColumnsOptions(state);
    const columnToRemoveIndex = columnOptions?.findIndex((c) => c.id === columnOptionId) ?? -1;
    if (columnOptions && columnToRemoveIndex !== -1) {
        return columnOptions[columnToRemoveIndex];
    }
    return null;
};
export const deleteColumnOptionState = (state, columnOptionId) => {
    const columnOptions = selectEditorSettingsColumnsOptions(state);
    const columnToRemoveIndex = columnOptions?.findIndex((c) => c.id === columnOptionId) ?? -1;
    if (columnToRemoveIndex !== -1) {
        columnOptions?.splice(columnToRemoveIndex, 1);
    }
};
